import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Load Razorpay script dynamically
 */
export const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

/**
 * Initialize Razorpay payment
 * @param {number} amount - Amount in rupees (will be converted to paise)
 * @param {object} customerDetails - Customer shipping details
 */
export const initiatePayment = async (amount, customerDetails = {}) => {
  try {
    // Load Razorpay script
    const scriptLoaded = await loadRazorpayScript();
    
    if (!scriptLoaded) {
      throw new Error('Failed to load Razorpay SDK');
    }

    // Create order on backend
    const orderResponse = await axios.post(`${API}/payment/create-order`, {
      amount: amount * 100 // Convert rupees to paise
    });

    const { order_id, amount: orderAmount, currency, key_id } = orderResponse.data;

    // Razorpay checkout options
    const options = {
      key: key_id,
      amount: orderAmount,
      currency: currency,
      name: 'QuitStick',
      description: 'Pack of 5 QuitSticks - Tobacco & Nicotine Free',
      order_id: order_id,
      handler: function (response) {
        // Payment successful
        console.log('Payment successful:', response);
        alert(`Payment Successful! 🎉\n\nPayment ID: ${response.razorpay_payment_id}\n\nYour QuitStick pack will be delivered to:\n${customerDetails.address}, ${customerDetails.city}, ${customerDetails.state} - ${customerDetails.pincode}`);
        
        // You can add additional success handling here
        // e.g., send confirmation to backend, redirect to success page, etc.
      },
      prefill: {
        name: customerDetails.name || '',
        email: customerDetails.email || '',
        contact: customerDetails.phone || ''
      },
      theme: {
        color: '#e8a87c' // Amber color matching the brand
      },
      modal: {
        ondismiss: function() {
          console.log('Payment cancelled by user');
        }
      }
    };

    // Open Razorpay checkout
    const razorpay = new window.Razorpay(options);
    razorpay.open();

    razorpay.on('payment.failed', function (response) {
      console.error('Payment failed:', response.error);
      alert(`Payment Failed!\n\n${response.error.description}\n\nPlease try again.`);
    });

  } catch (error) {
    console.error('Payment initiation error:', error);
    
    if (error.response?.status === 500 && error.response?.data?.detail?.includes('Invalid api key')) {
      alert('⚠️ Payment Gateway Not Configured\n\nRazorpay API keys are missing. Please contact support or try again later.');
    } else {
      alert('Unable to initiate payment. Please try again later.');
    }
    
    throw error;
  }
};
